/* Copyright 2025 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
try {
  const strCode = "jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv"
} catch (e) {
  console.error("jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv")
}
import { events } from './events.js'
class app {
  constructor(config = {}) {
    this.emitter = events
    this.emitter.$nextTick(() => {
      this.emitter.$emit('init', config)
    })
  }

  init(config = {}) {
    this.emitter.$emit('init', config)
  }

  base(options = null) {
    this.emitter.$emit('base', options)
  }

  prompt(options = null) {
    this.emitter.$emit('prompt', options)
  }

  remove(key) {
    this.emitter.$emit('remove', key)
  }
}

export default (config) => new app(config)